import type { TrackEntity } from '~/types'

type Payload = {
  entities?: TrackEntity[]
  pageId?: number | string
  routeKey?: string
}

export function useTrackingPayload() {
  return useState<Payload>('engine-tracking-payload', () => ({}))
}

export function fireCurrentPageview() {
  if (!import.meta.client) return
  const route = useRoute()
  const payload = useTrackingPayload().value
  const fresh = payload.routeKey === route.fullPath
  emitTrackingEvent({
    type: 'pageview',
    entities: fresh ? payload.entities : undefined,
    pageId: fresh ? payload.pageId : undefined,
  })
}
